/* ---------------------------------------------
   Install App Popup — Behaviour
   Minimal, dependency-free, hardware-accelerated.
--------------------------------------------- */
(function () {
  'use strict';

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setCookie(name, value, days) {
    var expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/; SameSite=Lax';
  }

  function detectStoreUrl(appUrl, playUrl) {
    var ua = navigator.userAgent || '';
    var isIOS = /iPhone|iPad|iPod/i.test(ua);
    var isAndroid = /Android/i.test(ua);
    if (isIOS && appUrl) return appUrl;
    if (isAndroid && playUrl) return playUrl;
    return appUrl || playUrl || '#';
  }

  function launchConfetti(canvas, originEl) {
    var ctx = canvas.getContext('2d');
    var dpr = window.devicePixelRatio || 1;
    canvas.width = window.innerWidth * dpr;
    canvas.height = window.innerHeight * dpr;
    canvas.style.width = window.innerWidth + 'px';
    canvas.style.height = window.innerHeight + 'px';
    ctx.scale(dpr, dpr);

    var rect = originEl.getBoundingClientRect();
    var originX = rect.left + rect.width / 2;
    var originY = rect.top + rect.height / 2;

    var colors = ['#d4af37', '#3f8f5f', '#3f7fd4', '#e08bb0', '#ffffff'];
    var particles = [];
    var count = 70;

    for (var i = 0; i < count; i++) {
      var angle = Math.random() * Math.PI * 2;
      var speed = 3 + Math.random() * 6;
      particles.push({
        x: originX,
        y: originY,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed - 4,
        size: 3 + Math.random() * 4,
        color: colors[Math.floor(Math.random() * colors.length)],
        rotation: Math.random() * Math.PI,
        rotSpeed: (Math.random() - 0.5) * 0.3,
        life: 1,
        shape: Math.random() > 0.5 ? 'rect' : 'circle'
      });
    }

    var start = null;
    var duration = 2200;

    function frame(ts) {
      if (!start) start = ts;
      var elapsed = ts - start;
      ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);

      particles.forEach(function (p) {
        p.vy += 0.12;
        p.x += p.vx;
        p.y += p.vy;
        p.rotation += p.rotSpeed;
        p.life = Math.max(0, 1 - elapsed / duration);

        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rotation);
        ctx.globalAlpha = p.life;
        ctx.fillStyle = p.color;
        if (p.shape === 'rect') {
          ctx.fillRect(-p.size / 2, -p.size / 4, p.size, p.size / 2);
        } else {
          ctx.beginPath();
          ctx.arc(0, 0, p.size / 2, 0, Math.PI * 2);
          ctx.fill();
        }
        ctx.restore();
      });

      if (elapsed < duration) {
        requestAnimationFrame(frame);
      } else {
        ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
      }
    }

    requestAnimationFrame(frame);
  }

  window.IAPInitPopup = function (root) {
    if (!root || root.dataset.iapInitialised) return;
    root.dataset.iapInitialised = 'true';

    var cookieName = 'popup_seen';
    var cookieDays = parseInt(root.dataset.cookieDays, 10) || 30;
    var delay = parseInt(root.dataset.delay, 10) || 2500;
    var confettiEnabled = root.dataset.confettiEnabled === 'true';
    var appUrl = root.dataset.appStoreUrl;
    var playUrl = root.dataset.playStoreUrl;

    var overlay = root.querySelector('[data-iap-overlay]');
    var card = root.querySelector('[data-iap-card]');
    var closeBtn = root.querySelector('[data-iap-close]');
    var clickzone = root.querySelector('[data-iap-clickzone]');
    var confettiCanvas = root.querySelector('[data-iap-confetti]');
    var lastFocused = null;
    var autoHideTimer = null;

    function focusableEls() {
      return root.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
    }

    function trapFocus(e) {
      if (e.key !== 'Tab') return;
      var focusables = focusableEls();
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    function onKeydown(e) {
      if (e.key === 'Escape') closePopup();
      trapFocus(e);
    }

    function openPopup() {
      lastFocused = document.activeElement;
      root.classList.add('iap-is-open');
      root.setAttribute('aria-hidden', 'false');
      // Mark as seen as soon as it's shown, so it won't reappear on the
      // next visit even if the visitor ignores it and navigates away.
      setCookie(cookieName, 'true', cookieDays);
      document.addEventListener('keydown', onKeydown);
      requestAnimationFrame(function () {
        closeBtn.focus();
      });
      // Auto-hide 3 seconds after the popup is shown, unless the visitor
      // closes it or taps install first (both go through closePopup, which
      // clears this timer so it never double-fires).
      autoHideTimer = setTimeout(closePopup, 3000);
    }

    function closePopup() {
      if (autoHideTimer) {
        clearTimeout(autoHideTimer);
        autoHideTimer = null;
      }
      root.classList.remove('iap-is-open');
      root.setAttribute('aria-hidden', 'true');
      document.removeEventListener('keydown', onKeydown);
      if (lastFocused && lastFocused.focus) lastFocused.focus();
      setCookie(cookieName, 'true', cookieDays);
    }

    function triggerInstall(originEl) {
      var url = detectStoreUrl(appUrl, playUrl);
      if (confettiEnabled && confettiCanvas) {
        launchConfetti(confettiCanvas, originEl);
      }
      if (url && url !== '#') {
        window.open(url, '_blank', 'noopener');
      }
      setTimeout(closePopup, confettiEnabled ? 900 : 150);
    }

    closeBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      closePopup();
    });

    if (overlay) {
      overlay.addEventListener('click', closePopup);
    }

    clickzone.addEventListener('click', function () {
      triggerInstall(clickzone);
    });

    if (!getCookie(cookieName)) {
      setTimeout(openPopup, delay);
    }
  };
})();